import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import ProjectSettingsSpacePoliciesQueryNode, {
	type ProjectSettingsSpacePoliciesQuery,
} from './__generated__/ProjectSettingsSpacePoliciesQuery.graphql.ts';

type Queries = {
	projectSettingsSpacePoliciesQuery: ProjectSettingsSpacePoliciesQuery;
};

type ProjectSettingsSpacePoliciesEntryPointComponent = EntryPointComponent<
	Queries,
	{},
	{},
	{ projectKey: string }
>;

export const projectSettingsSpacePoliciesEntryPoint: EntryPoint<
	ProjectSettingsSpacePoliciesEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<ProjectSettingsSpacePoliciesEntryPointComponent>(
		/* webpackChunkName: "async-project-settings-space-policies" */ './ProjectSettingsSpacePolicies.tsx',
	),
	getPreloadProps: ({ context: { match }, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const projectKey = match.params.projectKey;

		if (!projectKey) {
			throw new Error('projectKey is required');
		}

		return {
			extraProps: { projectKey },
			queries: {
				projectSettingsSpacePoliciesQuery: {
					parameters: ProjectSettingsSpacePoliciesQueryNode,
					variables: {
						cloudId,
						projectKey,
					},
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		};
	},
});
